// extracted by mini-css-extract-plugin
export default {"dropdown":"common-configurable-wizards-fields-SelectableGroupFieldInfo__dropdown--rqoJj"};